import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const EyeIcon = ({ width, height, color }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 13.078c4.418 0 8-5 8-5s-3.582-5-8-5-8 5-8 5 3.582 5 8 5zm0-2a3 3 0 100-6 3 3 0 000 6zm0-1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill={color}></path>
    </BaseIcon>
  );
};

export default EyeIcon;
